export class FolderTree {
  constructor(id = '', name = '', parent = null) {
    this.id = id;
    this.name = name;
    this.parent = parent;    
    this.parentid = '';
    this.level = '';
    this.foldpath = '/';
    this.items = [];    
  }

  addItem(item, index = -1) {
    //console.log('-------MsgTree addItem:index('+index+')--------');
    if (index === -1) {
      this.items.push(item);
    } else {
      this.items.splice(index, 0, item);
    }
  }

  listItems() {
    let result = [];
    this.items.forEach((item) => {
      result = result.concat(item.listItems().filter(item2 => result.find(item3 => item3.name === item2.name) === undefined));
    });

    return result;
  }

  // findItem(name) {
  //   return this.items.find(item => item.name === name);
  // }

  findItem(id) {
    return this.items.find(item => item.id === id);
  }

  toJson() {
    let object = {};
    object = { id: `${this.id}`, name: `${this.name}`,  parentid: `${this.parentid}`,  level: `${this.level}`,  foldpath: `${this.foldpath}`};
    object.children = [];

    this.items.forEach((item) => {
      object.children.push(item.toJson());
    });

    return object;
  }
}

// export default MsgTree;

